import { HULLS, type HullId } from "@frontier/content/definitions";
import { credits } from "./ui-labels";

export interface HullAcquisitionProps {
  market?: boolean;
  hullId: HullId;
  installed: HullId;
  owned: readonly HullId[];
  balance: string;
  components?: number;
  purchasingAllowed: boolean;
  busy: boolean;
  onInstall: (hullId: HullId) => Promise<void>;
  onPurchase: (hullId: HullId) => Promise<void>;
  onHangar?: () => void;
}

export function HullAcquisition({ market = false, hullId, installed, owned, balance, components = 0, purchasingAllowed, busy, onInstall, onPurchase, onHangar }: HullAcquisitionProps) {
  const hull = HULLS[hullId];
  const isOwned = owned.includes(hullId);
  const equipped = hullId === installed;
  const shortfall = BigInt(hull.price) - BigInt(balance);
  const missingComponents = Math.max(0, hull.componentPrice - components);
  const blocked = busy || equipped || (!isOwned && (!purchasingAllowed || shortfall > 0n || missingComponents > 0));
  const price = `${credits(hull.price)} КР${hull.componentPrice ? ` · ${credits(String(hull.componentPrice))} комп.` : ""}`;
  const shortage = shortfall > 0n || missingComponents > 0
    ? `Не хватает ${shortfall > 0n ? `${credits(shortfall.toString())} КР` : ""}${missingComponents ? ` ${credits(String(missingComponents))} комп.` : ""}`
    : "";
  if (market) return <div className="market-purchase-bar" aria-label="Покупка корабля">
    <div className="market-purchase-price"><span>{isOwned ? (equipped ? "АКТИВНЫЙ КОРАБЛЬ" : "В ТВОЁМ АНГАРЕ") : "СТОИМОСТЬ"}</span>
      <b>{isOwned ? hull.name : price}</b>{shortage && !isOwned && <small>{shortage}</small>}</div>
    {isOwned ? <button className="market-hangar-button" onClick={onHangar}>В АНГАР →</button> :
      <button className="ship-install" aria-label={`Купить корпус «${hull.name}»`} disabled={blocked} onClick={() => { if (!blocked) void onPurchase(hullId); }}>{busy ? "Ожидание…" : "Купить корабль"}</button>}
  </div>;
  return <div className="ship-acquisition">
    {equipped ? <span className="ship-ready">● ГОТОВ К ОТСТЫКОВКЕ</span> : <button className="ship-install"
      aria-label={isOwned ? `Установить корпус «${hull.name}»` : `Купить корпус «${hull.name}»: ${credits(hull.price)} КР${hull.componentPrice ? ` + ${hull.componentPrice} КОМП.` : ""}`}
      disabled={blocked} onClick={() => { if (!blocked) void (isOwned ? onInstall(hullId) : onPurchase(hullId)); }}>
      <span>{isOwned ? "ВЫБРАТЬ КОРАБЛЬ" : `КУПИТЬ · ${credits(hull.price)} КР${hull.componentPrice ? ` + ${hull.componentPrice} КОМП.` : ""}`}</span>
      <small>{isOwned ? "БЕСПЛАТНО · СБОРКА СОХРАНЯЕТСЯ" : shortage || "ДОБАВИТЬ В АНГАР"}</small>
    </button>}
  </div>;
}
